export default "__VITE_ASSET__e544d86b__"